import React, { Fragment, useState } from 'react'
import { Row, Button, Col, Modal, Container, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getCasoImplicado } from '../../api/api-visar-provision';
import VisaProvisionesModal from './visar-provision';
import { useNavigate } from 'react-router-dom'

import Bitacora from '../bitacora';
import {CarpetaDigitalComponent} from 'reccol-caso-general'
import {BitacoraComponent} from 'recupero-bitacora'
import { Auth } from 'recupero-comunes'

import VerPretensionesModal from './ver-pretensiones';

const Acciones = ({ implicadoSeleccionado, origen }) => {

    const history =useNavigate()

    const data_admnistracion = useSelector((state) => state.administracionCasoReducer);
    const { cfg_form43 } = data_admnistracion;

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    const [action, setAction] = useState("");
    const [showVisarProvision, setShowVisarProvision] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [bodyInfo, setBodyInfo] = useState("");

    const queryState=localStorage.getItem('filtrosAreaGestion') ? JSON.parse(localStorage.getItem('filtrosAreaGestion')) : 
        JSON.parse(localStorage.getItem('query'))

    const [showBitacora, setShowBitacora] = useState(false)
    const [showCarpeta, setShowCarpeta] = useState(false)
    const [showPretensiones, setShowPretensiones] = useState(false)
    
    const handleShowBitacora = () => setShowBitacora(true)
    const handleCloseBitacora= () => setShowBitacora(false)
    
    const handleCloseCarpeta= () => setShowCarpeta(false)
    const handleShowCarpeta= () => setShowCarpeta(true)

    const handleClosePretensiones= () => setShowPretensiones(false)
    const handleShowPretensiones= () => setShowPretensiones(true)

    const handleVisar = async (action) => {
        const query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves['idCaso'], idImplicado: implicadoSeleccionado })).toString('base64');
        const response = await getCasoImplicado(query);
        
        const result = (action === "provision") ? response[0]?.ultimaProvision : response[0]?.ultimaPropuestaIndeminizacion;
        
        if (response && result?.Secuencia) {
            setAction(action);
            setShowVisarProvision(true);
        } else {
            setShowVisarProvision(false);
            setShowModalInfo(true);
            setBodyInfo(action === "provision" ? "Implicado sin provisión enviada." : "Implicado sin propuesta de indemnización enviada.");
        }
    }
    const handleVolver = () => {    
        if (origen == "casosReserva") { 
            setTimeout(()=> history('/busqueda-casos-reserva',{state:{queryState}}),10)      
        } else {
            setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),10)      
        }
    }
    return (
        <Fragment>
            {/*<Bitacora
                handleCloseBitacora={handleCloseBitacora}
                showBitacora={showBitacora}
            />*/}
            <Modal size="xl" show={showBitacora} onHide={handleCloseBitacora}>        
                <Modal.Body>
                <BitacoraComponent user={Auth.currentUser().rutUsuario} rutcia={llaves && llaves['idOrgCaso']} idCaso={llaves && llaves["idCaso"]}/> 
                </Modal.Body>                
                <Modal.Footer>
                    <Button variant='primary' onClick={handleCloseBitacora}>
                    Cerrar
                    </Button>
                </Modal.Footer>
                
            </Modal>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
                    idCaso={llaves && llaves['idCaso']}
                    idImplicado={llaves && llaves['idImplicado']}
                    idOrganizacionCaso={llaves && llaves['idOrgCaso']}
                    prototipo={2}
                    />  
            </Modal>
            <VisaProvisionesModal
                action={action}
                showModal={showVisarProvision}
                setShowModal={setShowVisarProvision}
                implicado={implicadoSeleccionado}
            />
            <VerPretensionesModal
                handleClosePretensiones={handleClosePretensiones}
                showPretensiones={showPretensiones}
            />

            <Container>
                <Row>
                    <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleVolver}>
                            {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-volver"]}
                        </Button>
                        <Button className='m-2' variant='cambiar' onClick={handleShowBitacora}>
                            {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-bitacora"]}
                        </Button>
                        <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                            {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-carpeta"]}
                        </Button> 
                        {/*<Button className='m-2' variant='cambiar' onClick={handleShowPretensiones}>
                            Ver Pretensiones                            
                        </Button>*/}
                        {/*<Button disabled={!implicadoSeleccionado} className='m-2' variant='bitacora' onClick={() => handleVisar("provision")}>
                            {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-visarprovision"]}
                        </Button>*/}
                        {/*<Button disabled={!implicadoSeleccionado} className='m-2 w-auto' variant='bitacora' onClick={() => handleVisar("indemniza")}>
                            {cfg_form43 && cfg_form43.cfg_form43["formbasegestiondefensacia-btn-visarpptaindem"]}
                        </Button>*/}
                    </Col>
                </Row>
            </Container>

            <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>Información</Card.Header>
                    <Card.Body>{bodyInfo}</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalInfo(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                .btn-carpeta {
                    background-color: #F0AD3E;
                    color: #FFFFFF;
                    width: 140px;
                    
                }
                .btn-carpeta:hover{
                    background-color:#e1b97f;
                    color: #FFFFFF;
            
                }
                .btn-bitacora {
                    background-color: #55B2CE;
                    color: #FFFFFF;
                    width: 140px;
                }
                .btn-bitacora:hover{
                    background-color: #87c9dc;
                    color: #FFFFFF;
                } 
                .btn-cambiar {
                    background-color:  #286FBF;
                    color: #FFFFFF;
                    width: 140px;     
                    padding:6px 0px 6px 0px;
                }
                .btn-cambiar:hover{
                    background-color:  #5b9ad1;
                    color: #FFFFFF;
                }
                .btn-actualizar {
                    background-color: #C14B49;
                    color: #FFFFFF;
                    width: 140px;
                    padding:6px 0px 6px 0px;
            
                }
                .btn-actualizar:hover{
                    background-color:  #F6897E;
                    color: #FFFFFF;
                }
                .btn-recepcionar {
                    background-color: #C14B49;
                    color: #FFFFFF;
                    width: 140px;
                    padding:6px 0px 6px 0px;
            
                }
                .btn-recepcionar:hover{
                    background-color: #F6897E;
                    color: #FFFFFF;
                }
                .btn-volver {
                    
                    color: #66CCCC;
                    border: 1px solid #C00
                
                    width: 140px;
            
                }
                .btn-tamano{
                    padding: 1rem 1.5rem;
                    font-size: 1.5rem;
                }
            `}
            </style>
        </Fragment>
    )
}

export default Acciones;
